import script from "./CoverageRankChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverageRankChip.vue?vue&type=script&setup=true&lang=js"

import "./CoverageRankChip.vue?vue&type=style&index=0&id=01d770e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d770e2"]])

export default __exports__